import { Injectable } from '@angular/core';
import { BasePagedCrudService } from '../shared/crud/base-crud.service';
import { PrenosUcetniJednotkaDto, CreatePrenosUcetniJednotkaDto, EditPrenosUcetniJednotkaDto } from './models/PrenosUcetniJednotka';
import { HttpClient } from '@angular/common/http';
import { CrudSettings, QueryParams } from '../shared/crud/abstractions/base-crud';
import { EnvironmentService } from '../core/environment/environment.service';
import {DialogService} from "../shared/dialog/dialog.service";
import {MatSnackBar} from "@angular/material/snack-bar";

export class PrenosUcetniJednotkaCrudSettings implements CrudSettings<string, PrenosUcetniJednotkaDto> {
    baseUrl = '';
    postUrl = undefined;
    queryParam = undefined;
    createSuffix = undefined;
    deleteSuffix = undefined;
    deleteIdLocation: 'PATH' | 'QUERY' = 'QUERY';
    editSuffix = undefined;
    editIdLocation: 'PATH' | 'QUERY' = 'QUERY';
    editMethod: 'PUT' | 'PATCH' = 'PUT';
    getListSuffix = 'Vse';
    getSuffix = undefined;
    getIdLocation: 'PATH' | 'QUERY' = 'QUERY';
    idGetter = (entity: PrenosUcetniJednotkaDto) => entity.kodUj;

    mapper(kodUj: string): QueryParams {
      const dict = new Map<string, string>();
      dict.set('kodUj', kodUj);
      return { params: dict }
    }

    constructor(private environmentService: EnvironmentService) {
      this.baseUrl = this.environmentService.getConfig().api.pubgw + '/api/ETL/PrenosUcetniJednotky';
    }
}

@Injectable({
  providedIn: null
})
export class PrenosUcetniJednotkaDataService
  extends BasePagedCrudService<string, PrenosUcetniJednotkaDto, CreatePrenosUcetniJednotkaDto, EditPrenosUcetniJednotkaDto>{

  constructor(private _http: HttpClient, private environmentService: EnvironmentService, override dialogService: DialogService) {
    super(_http, new PrenosUcetniJednotkaCrudSettings(environmentService), dialogService);
  }
}
